import { useParams, useSearchParams } from 'react-router-dom';

import { AppPublicPreviewPage } from '~/components/pages/AppPublicPreviewPage';
import { Navigate } from '~/components/utils/Navigation';

export const AppPublicPreviewRoute: React.FC = () => {
  const { appUri } = useParams();
  const [searchParams] = useSearchParams();

  if (!appUri) {
    return <Navigate to="/" />;
  }

  return (
    <AppPublicPreviewPage
      appUri={appUri}
      previousUrl={searchParams.get('previousUrl') ?? undefined}
    />
  );
};
